// extracted by mini-css-extract-plugin
export default {"container":"SuZ3pf mz-default-dark-font"};